import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';
import { HoverBox } from '../../../hoverBox/HoverBox';

export const MfeRetracementLine = observer(
  ({
    tradePlanId,
    isInRetrace,
    maxMfe,
    activateMfePositionPrice,
    retraceMfePositionPrice,
    size,
    scaleY,
    portalRef,
    fillPrice,
    openQuantity,
    priceMultiplier,
    realizedPnl,
    isLong,
    tickSize,
    delta,
  }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
    const retracePct = tradePlan?.exitTactics['MFE_RETRACEMENT']?.retracePct ?? null;
    const mfeType = tradePlan?.exitTactics['MFE_RETRACEMENT']?.mfeType ?? null;
    const paused = tradePlan?.exitTactics['MFE_RETRACEMENT']?.paused ?? null;

    const linePrice = isInRetrace
      ? Number(retraceMfePositionPrice)
      : Number(activateMfePositionPrice);

    const json = {
      Category: 'Exit Tactic',
      Type: 'MFE Retracement',
      'Retrace Pct': `${Number(retracePct) * 100}%`,
      'Current Max': `${ApplyRounding(Number(maxMfe), 2)}${mfeType === 'byPnl' ? '(Pnl)' : ''}`
    };

    return (
      <>
        {scaleY ? (
          <>
            {paused ? (
              <line
                strokeDasharray={4}
                stroke={isInRetrace ? colors.red : colors.orange}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={scaleY(linePrice)}
                y2={scaleY(linePrice)}
              />
            ) : (
              <line
                stroke={isInRetrace ? colors.red : colors.orange}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={scaleY(linePrice)}
                y2={scaleY(linePrice)}
              />
            )}
            <HoverBox
              json={json}
              topBoundary={scaleY(linePrice) - 2}
              bottomBoundary={scaleY(linePrice) + 2}
              leftBoundary={0}
              rightBoundary={size}
              portalRef={portalRef}
              size={size}
              linePrice={linePrice}
              tickSize={tickSize}
              fillPrice={fillPrice}
              openQuantity={openQuantity}
              priceMultiplier={priceMultiplier}
              realizedPnl={realizedPnl}
              isLong={isLong}
              delta={delta}
            />
          </>
        ) : null}
      </>
    );
  }
);
